export const COLORS = {
    Blue: '#0aaee4',
};
